import { EditorState } from "@tiptap/pm/state";
import { EditorView } from "@tiptap/pm/view";
import { Editor } from "@tiptap/react";

import { TableMap } from "@tiptap/pm/tables";

import Table from "../../Table.js";
import { findTable, isTableSelected } from "../../utils.js";

export const isRowGripSelected = ({
  editor,
  view,
  state,
  from,
}: {
  editor: Editor;
  view: EditorView;
  state: EditorState;
  from: number;
}) => {
  const domAtPos = view.domAtPos(from).node as HTMLElement;
  const nodeDOM = view.nodeDOM(from) as HTMLElement;
  const node = nodeDOM || domAtPos;

  if (!editor.isActive(Table.name) || !node) {
    return false;
  }

  // One-row tables: selecting that row selects every cell, so isTableSelected is true —
  // still show the row menu so users can add rows.
  const table = findTable(state.selection);
  if (table && isTableSelected(state.selection)) {
    const map = TableMap.get(table.node);
    if (map.height !== 1) {
      return false;
    }
  }

  let container = node;

  while (container && !["TD", "TH"].includes(container.tagName)) {
    container = container.parentElement!;
  }

  const gripRow =
    container &&
    container.querySelector &&
    container.querySelector("a.grip-row.selected");

  return !!gripRow;
};

export default isRowGripSelected;
